import { useTranslation } from 'react-i18next';

import { cn } from '@/lib/cn';

/** A small spinning ring, `accent` colored. `role="status"` with an
 * `sr-only` label for screen readers/tests. */
export function Spinner({ className }: { className?: string }) {
  const { t } = useTranslation();

  return (
    <span
      role="status"
      className={cn(
        'border-mint-tint border-t-accent inline-block size-5 animate-spin rounded-full border-2 motion-reduce:animate-none',
        className,
      )}
    >
      <span className="sr-only">{t('ui.loading')}</span>
    </span>
  );
}
